import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("api/help");

// 预约上门提交
const commitAppointmentAsync = (param) => {
    return remoteCall.invoke("commitAppointment", param);
};

// 查询预约上门提交的json
const findAppointmentAsync = (param) => {
    return remoteCall.invoke("findAppointment", param);
};

// 获取最新的升级公告
const findNowNoticeAsync = (param) => {
    return remoteCall.invoke("findNowNotice", param);
};

/**
 * 提交意见反馈
 * @param arg
 * @returns {*}
 */
function commitSurveyAsync(arg) {
    return remoteCall.invoke("commitSurvey", arg);
}

/**
 * 用户通用简单信息提交
 * @param arg
 * @returns {*}
 */
function commitAsync(arg) {
    return remoteCall.invoke("commit", arg);
}

/**
 * 查询通用简单信息
 * @param arg
 * @returns {*}
 */
function getConfigAsync(arg) {
    return remoteCall.invoke("getConfig", arg);
}

/**
 * 获取加群的链接
 * @param arg
 * @returns {*}
 */
function getChatGroupUrlAsync(arg) {
    return remoteCall.invoke("getChatGroupUrl", arg);
}

export default {
    commitAppointmentAsync,
    findAppointmentAsync,
    findNowNoticeAsync,
    commitSurveyAsync,
    commitAsync,
    getConfigAsync,
    getChatGroupUrlAsync,
};
